<p>menu-item-create-page-info works!</p>
